module.exports = __webpack_public_path__ + "static/logo-36623cbe37127c1705b9976baccb4fec.png";